import { useState } from 'react';

/** L'envoi d'un formulaire : bouton désactivé pendant l'écriture, erreur affichée si elle échoue. */
export function useEnvoi() {
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);

  async function lancer(action: () => Promise<void>): Promise<boolean> {
    setEnvoi(true);
    setErreur(null);
    try {
      await action();
      return true;
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'L’enregistrement n’a pas abouti.');
      return false;
    } finally {
      setEnvoi(false);
    }
  }

  return { envoi, erreur, lancer };
}
